// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip-container{width:228px;padding:.6rem 1rem;line-height:150%;font-weight:400;font-size:.9375rem}`, "",{"version":3,"sources":["webpack://./src/components/Tooltip/index.scss"],"names":[],"mappings":"AAAA,mBACE,WAAA,CACA,kBAAA,CACA,gBAAA,CACA,eAAA,CACA,kBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
